"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentMeta = void 0;
var Edition_1 = require("./Edition");
var ContentLifecycle_1 = require("./ContentLifecycle");
var FragmentMeta_1 = require("./FragmentMeta");
/**
 * Class providing meta data about a content item with helper functions.
 */
var ContentMeta = /** @class */ (function (_super) {
    __extends(ContentMeta, _super);
    /**
     * Creates a new ContentMeta instance.
     * @param data JSON representation of the ContentMeta model
     */
    function ContentMeta(data) {
        var _this = _super.call(this, data) || this;
        if (data) {
            if (data.edition) {
                _this.edition = new Edition_1.Edition(data.edition);
            }
            if (data.lifecycle) {
                _this.lifecycle = new ContentLifecycle_1.ContentLifecycle(data.lifecycle);
            }
        }
        return _this;
    }
    /**
     * Export to JSON
     */
    ContentMeta.prototype.toJSON = function () {
        var result = _super.prototype.toJSON.call(this);
        if (this.deliveryId) {
            result.deliveryId = this.deliveryId;
        }
        if (this.deliveryKey) {
            result.deliveryKey = this.deliveryKey;
        }
        if (this.name) {
            result.name = this.name;
        }
        if (this.edition) {
            result.edition = this.edition.toJSON();
        }
        if (this.lifecycle) {
            result.lifecycle = this.lifecycle.toJSON();
        }
        if (this.hierarchy) {
            result.hierarchy = this.hierarchy;
        }
        return result;
    };
    /**
     * @hidden
     * Returns true if the provided node is a content item meta data object
     * @param node JSON node to test
     */
    ContentMeta.isContentMeta = function (node) {
        return (node != null &&
            node.schema != null &&
            (node.name != null || node.deliveryId != null));
    };
    /**
     * @hidden
     * Returns true if the provided node is a content body object
     * @param node JSON node to test
     */
    ContentMeta.isContentBody = function (node) {
        return node != null && this.isContentMeta(node._meta);
    };
    return ContentMeta;
}(FragmentMeta_1.FragmentMeta));
exports.ContentMeta = ContentMeta;
//# sourceMappingURL=data:application/json;base64,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